import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";
import { SharedModule } from "../../shared/shared.module";
import { DisclaimersEffects } from "./disclaimers.effects";
import { DisclaimersService } from "./disclaimers.service";
import { disclaimersReducer } from "./disclaimers.reducer";
import { DisclaimersComponent } from "./disclaimers.component";
import { DisclaimerAddComponent } from "./disclaimer-add/disclaimer-add.component";
import { DisclaimerEditComponent } from "./disclaimer-edit/disclaimer-edit.component";
import { DisclaimerComponent } from "./disclaimer/disclaimer.component";
import { MatDialogModule } from "@angular/material/dialog";

@NgModule({
  declarations: [
    DisclaimerComponent,
    DisclaimerAddComponent,
    DisclaimerEditComponent,
    DisclaimersComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    SharedModule,
    MatDialogModule,
    StoreModule.forFeature("disclaimers", disclaimersReducer),
    EffectsModule.forFeature([DisclaimersEffects]),
  ],
  providers: [DisclaimersService],
  exports: [
    DisclaimerComponent,
    DisclaimerAddComponent,
    DisclaimerEditComponent,
    DisclaimersComponent,
  ],
})
export class DisclaimersModule {}
